import { FixedDateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { AggregatePeriod } from 'v2/core/entities';

export function getAggregatePeriodFromFixedDateRange(
  dateRange: FixedDateTimeRange,
) {
  if (!dateRange.startAfter || !dateRange.endBefore) {
    return;
  }

  const diff = dateRange.endBefore.diff(dateRange.startAfter, 'day');

  return diff < 30
    ? AggregatePeriod.DAY
    : diff < 90
    ? AggregatePeriod.WEEK
    : AggregatePeriod.MONTH;
}
